<template>
  <div>
    <!-- Componente nuevo (Vue3) para fechas >= 2025-07-29 -->
    <!-- translate="no": la traducción del navegador reescribe el texto y Quill lo borra -->
    <klv3-rich-text-component
      v-if="show_rich_text && useNewComponent"
      ref="richTextEditor"
      translate="no"
      :content-rich-text="content_rich_text"
      :valid-state="valid_state"
      :auto-save="auto_save"
      @save="saveNewContent"
    ></klv3-rich-text-component>
    <!-- Componente anterior para fechas < 2025-07-29 -->
    <NewRichTextEditor
      v-if="show_rich_text && !useNewComponent"
      class="rich-text-editor-scroll"
      :Text="content_rich_text"
      :valid-state="valid_state"
      :permit_blank="permit_blank"
      :hide_title="hide_title"
      :auto_save="auto_save"
      @save="saveOldContent"
    >
    </NewRichTextEditor>
  </div>
</template>

<script>
export default {
  name: "ViewContainerRichTextKlv3",
  components: {
    NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
  },
  props: {
    object_rich_text: {
      type: Object,
    },
    content_rich_text: {
      type: String,
      default: "",
    },
    auto_save: {
      type: Boolean,
      default: false,
    },
    valid_state: {
      type: Boolean,
      default: false,
    },
    permit_blank: {
      type: Boolean,
      default: false,
    },
    hide_title: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show_rich_text: false,
      editor_initialized: false,
    };
  },
  computed: {
    useNewComponent() {
      // Si no hay objeto (creando nuevo contenido), usar componente nuevo
      if (!this.object_rich_text) {
        return true;
      }
      // Si el ID no es un número válido (objeto nuevo), usar el componente nuevo
      if (isNaN(this.object_rich_text.id)) {
        return true;
      }
      // Si no hay creation_date pero tiene ID numérico (objeto existente sin fecha), usar componente antiguo
      if (!this.object_rich_text.creation_date) {
        return false;
      }
      // Si tiene creation_date, comparar con la fecha de corte
      const creationDate = new Date(this.object_rich_text.creation_date);
      const cutoffDate = new Date("2025-09-10T20:00:00.000Z");

      return creationDate >= cutoffDate;
    },
  },
  methods: {
    initRichTextComponent() {
      this.show_rich_text = false;
      this.editor_initialized = false;
      this.$nextTick(() => {
        this.show_rich_text = true;
        // Dar tiempo para que el editor se inicialice completamente
        setTimeout(() => {
          this.editor_initialized = true;
        }, 500);
      });
    },
    // Evento para cuando se trae un emit desde el proyecto de vue3 transforma el arreglo a un string
    saveNewContent(event) {
      let content;
      // El contenido del texto enriquecido viene de event.detail
      if (event.detail) {
        content = Array.isArray(event.detail) ? event.detail[0] : event.detail;
      }
      this.$emit("save", content);
    },
    saveOldContent(content) {
      this.$emit("save", content);
    },
  },
  mounted() {
    this.initRichTextComponent();
    // Escuchar evento global para reinicialización
    this.$root.$on(
      "reinitialize-rich-text-components",
      this.initRichTextComponent
    );
  },
  watch: {
    object_rich_text: {
      handler(newVal, oldVal) {
        // Reinicializar cuando cambie el objeto (por ejemplo, después del reordenamiento)
        if (newVal !== oldVal && this.show_rich_text) {
          this.initRichTextComponent();
        }
      },
      deep: true,
    },
  },
  created() {},
  beforeDestroy() {
    // Limpiar listener del evento global
    this.$root.$off(
      "reinitialize-rich-text-components",
      this.initRichTextComponent
    );
  },
};
</script>

<style scoped>
.rich-text-editor-scroll >>> .ql-editor {
  max-height: 300px;
  overflow: auto;
}
</style>